<template>
    <div class="footer-container">
        © Copyright Media Tech 2025. All rights reserved. <a :href="url" target="_blank"> 沪ICP备2024102204号-1</a>
    </div>
</template>
<script>
export default {
    data() {
        return {
            url: 'http://beian.miit.gov.cn/'
        }
    },
    methods: {
        openNewTab() {
            window.open(this.url,'_blank');
        }
    }
}
</script>
<style scoped>
    .footer-container {
        position: absolute;
        bottom: 0px;
        display: flex;
        flex-direction: row;
        align-items: center;
        /* width: 100%; */
        width: 20.08rem;
        height: 1rem;
        line-height: 1rem;
        background: #10163e;
        font-size: 0.24rem;
        color: #c5d4fe;
        padding: 0px 0.64rem;
        box-sizing: border-box;
        user-select: none;
    }

    a {
        color: #c5d4fe;
        text-decoration: none;
    }
</style>
